import { render, staticRenderFns } from "./MultipleChoiceDataSetQuestion.vue?vue&type=template&id=486881f8&scoped=true&"
import script from "./MultipleChoiceDataSetQuestion.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceDataSetQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486881f8",
  null
  
)

export default component.exports